import { connect } from 'react-redux'
import { sagaActions as rootSagaActions } from 'store/sagas'
import userActivitiesSelector from './userActivitiesSelector'
import {
  setUserId
} from 'store/redux/userActivities'
import UserActivities from './UserActivities'

export default connect(
  userActivitiesSelector,
  {
    fetchUserActivities: rootSagaActions.fetchUserActivities,
    requestChangeUserSettings: rootSagaActions.requestChangeUserSettings,
    setUserId
  }
)(UserActivities)
